import type { ISEOProps } from "../types/core";

export const MessagesPageSEO: ISEOProps = {
  title: "Messages - Sugar Cribs",
  description:
    "Connect with creators and fans through private messages on Sugar Cribs. Start conversations and build relationships.",
};
